export default __webpack_public_path__ + "static/media/home-freelancer-img-02.fc1e0a6d.png";